import { ChevronRight } from 'lucide-react';
import type { ActionListBlock } from '../chat-content';

export function ActionListBlockRenderer({ block }: { block: ActionListBlock }) {
  return (
    <div className="w-full space-y-1.5">
      {block.heading && (
        <p className="text-xs font-semibold uppercase tracking-widest text-muted-foreground px-0.5">
          {block.heading}
        </p>
      )}
      <div className="overflow-hidden rounded-lg border border-border divide-y divide-border">
        {block.items.map((item, i) => (
          <div
            key={i}
            className="flex items-center gap-3 px-4 py-2.5 bg-card hover:bg-muted/40 transition-colors cursor-default"
          >
            {item.icon && (
              <span className="shrink-0 text-base leading-none" aria-hidden>
                {item.icon}
              </span>
            )}
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium text-foreground truncate">{item.label}</p>
              {item.description && (
                <p className="text-xs text-muted-foreground truncate mt-0.5">{item.description}</p>
              )}
            </div>
            <ChevronRight className="size-4 shrink-0 text-muted-foreground" />
          </div>
        ))}
      </div>
    </div>
  );
}
